import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ContentPasteSearchIcon(props: IconProps) {
    return <Icon {...props} iconKey={"content_paste_search"}/>
}
